import { z } from 'zod';

export const subscribeSchema = z.object({
  billingName: z.string().min(1, 'Full name is required'),
  address: z.string().min(1, 'Address is required'),
  address2: z.string(),
  city: z.string().min(1, 'City is required'),
  state: z.string().min(1, 'State is required'),
  zip: z.string().min(1, 'Zip is required'),
  country: z.string().min(1, 'Country is required'),
  code: z.string(),
  subscriptionType: z.string().min(1, 'Please select a subscription type'),
});

export type SubscribeFormValues = z.infer<typeof subscribeSchema>;
